module.exports = __webpack_public_path__ + "static/media/hr.0d0d251a.svg";